export const DEFAULT_LANGUAGE = 'es_ES';
